import type { FormExtractorResponse, FormGeneratorResponse } from '@/types/material/formulation';
import { PsHttpService, type PatSnapCommonResponseData } from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';

@injectable()
export class MaterialFormulationApiImpl extends PsHttpService implements MaterialFormulationApi {
    get options() {
        return {
            baseURL: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka/material/formulation`,
            headers: {
                'X-API-Version': '1.0',
            },
        };
    }

    getExtractedData(agent_job_id: string, doc_id: string) {
        return this.get<PatSnapCommonResponseData<FormExtractorResponse>>({
            url: '/get-extracted-data',
            params: {
                agent_job_id,
                doc_id,
            },
        }).then(res => {
            return res.data as FormExtractorResponse
        })
    }

    getGeneratedData(agent_job_id: string, set_version: string) {
        return this.get<PatSnapCommonResponseData<Record<string, any>>>({
            url: '/get-generated-data',
            params: {
                agent_job_id,
                set_version,
            },
        }).then(res => {
            return res.data as FormGeneratorResponse
        })
    }
}

export const MaterialFormulationApi = Symbol('MaterialFormulationApi');

export interface MaterialFormulationApi {
    getExtractedData(agent_job_id: string, doc_id: string): Promise<FormExtractorResponse>;
    getGeneratedData(agent_job_id: string, set_version: string): Promise<FormGeneratorResponse>;
}
